"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remCalc = void 0;
var remCalc = function (px) { return 0.0625 * px + "rem"; };
exports.remCalc = remCalc;
